// extracted by mini-css-extract-plugin
module.exports = {"outer":"EditorWidgets_outer__Zbml_","inner":"EditorWidgets_inner__KJG_G","whiteBackground":"EditorWidgets_whiteBackground__Ry4dx"};